module.exports = new __parcel__URL__("plans-review-changes.d344422b.gif").toString();